// Utilities
import { createSimpleFunctional } from '@/util'

export const VOtpSeparator = createSimpleFunctional('v-otp-input__divider')

export type VOtpSeparator = InstanceType<typeof VOtpSeparator>
